module.exports = __webpack_public_path__ + "static/motion-2-ca538e914c10828aa8a225b995aba19d.mp4";